import { map, switchMap, catchError } from 'rxjs/operators'
import { defer, of, NEVER, Observable, EMPTY } from 'rxjs'
import { Epic, ofType } from 'redux-observable'
import { setIsLogged } from '../../actions/auth/SetIsLogged'
import SessionStorage from '../../../storage/session-storage/SessionStorage'
import { AuthRepository } from '../../../../repositories/auth/AuthRepository'
import { AuthApiDataHandler } from '../../../../data-handlers/auth/AuthApiDataHandler'
import { RequestLogin, requestLoginFailure, requestLoginSuccess } from '../../actions/auth/RequestLogin'
import AuthActionTypes from '../../actions/auth/AuthActionTypes'
import { Logout } from '../../actions/auth/Logout'

const authRepository = new AuthRepository(new AuthApiDataHandler())
/**
 * Request api for login
 */
 export const requestLoginEpic = (
  action$: Observable<RequestLogin>
) =>
  action$.pipe(
    ofType(AuthActionTypes.REQUEST_LOGIN),
    switchMap((action) =>
      defer(
        () => authRepository.requestAuth(action.payload.email, action.payload.password)
      ).pipe(
        map((response) => {
          authRepository.setAuth(response.token)
          SessionStorage.set('basic.auth', {
            token: response.token,
          })
          return requestLoginSuccess(response.token)
        }
        ),
        catchError((error) => of(
          requestLoginFailure(error)
        ))
      )
    )
  )

/**
 * Set token on app init
 */
export const setAuthOnInitEpic: Epic = (
  action$
) =>
  action$.pipe(
    ofType('APP_INIT'),
    map(() => SessionStorage.get<IAuthStored>('basic.auth')),
    switchMap(
      (data?: IAuthStored) => {
        if (!data) {
          return NEVER
        }

        const {
          token,
        } = data

        authRepository.setAuth(token)
        return of(setIsLogged(true))
      }
    )
  )

/**
 * Logout side effects
 */
 export const logoutEpic = (
  action$: Observable<Logout>
) =>
  action$.pipe(
    ofType(AuthActionTypes.LOGOUT),
    map(() => {
      authRepository.setAuth('')
      SessionStorage.set('basic.auth', {
        token: '',
      })
      return EMPTY
    })
  )


export const authEpics = [
  setAuthOnInitEpic,
  requestLoginEpic,
  logoutEpic,
]

export interface IAuthStored {
  user: string,
  token: string,
}
